import Block from "components/layout/block";
import { Fragment } from "react";
import PasswordForm from "./password-form";

const SecurityTab = () => {
  return (
    <Fragment>
      <Block title="Salasanan vaihto">
        <PasswordForm />
      </Block>
    </Fragment>
  );
};

export default SecurityTab;
